module.exports = __webpack_public_path__ + "static/media/bienvenida-nav.2dde890e.png";